<template>
  <a-layout>
    <a-divider>{{$t('business.label.validInfo')}}</a-divider>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="height"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :edit-render="{name:'VxeNumberInput'}" field="days" title="business.label.daysOfValid"/>
      <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>openModal('itemCategoryModal',{available:true},row)}}" field="itemCategory.name" title="business.label.categoryName"/>
      <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>openModal('itemCategoryModal',{available:true},row)}}" field="itemCategory.no" title="business.label.categoryNo"/>
      <vxe-column :edit-render="{name:'VxeInput',events:{click:({row})=>openModal('itemModal',{available:true},row)}}" field="item.name" title="business.label.itemName"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
    <item-modal ref="itemModal" @change="(rlt,row)=>row.item=changeItem(rlt[0])"/>
    <field-modal ref="itemCategoryModal" :no=itemCategoryNo :show-value="false" :title="$t('business.label.itemCategory')" @change="(rlt,row)=>row.itemCategory=changeItemCategory(rlt[0])"/>
  </a-layout>
</template>

<script>
import Vue from 'vue'
import { findAll, findOne, saveAll } from '@/api/Api'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import FieldModal from '@/views/modal/FieldModal.vue'
import ItemModal from '@/views/modal/ItemModal.vue'
import { Dictionary } from '@/api/dto/admin/Dictionary'
import { Item } from '@/api/dto/common/Item'
import { ValidityConfig } from '@/api/dto/config/ValidityConfig'

export default {
  name: 'ValidConfigTable',
  components: {
    ItemModal,
    FieldModal
  },
  data() {
    return {
      loading: false,
      data: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      warehouseData: [],
      classification: new Dictionary(),
      itemCategoryNo: '',
      contentSize: 0,
      page: 1,
      size: 20,
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.7575),
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        'itemCategory.name': [
          { required: true, type: 'string', message: '商品类别不能为空' }
        ],
        'itemCategory.no': [
          { required: true, type: 'string', message: '商品类别不能为空' }
        ],
        days: [
          { required: true, type: 'number', message: '效期天数不能为空' }
        ]
      }
    }
  },
  mounted() {
    findOne('parameterFactory', { name: '商品类别层级' }).then(res => {
      if (res.success) {
        this.itemCategoryNo = res.result.value
      }
    })
    findAll('warehouseFactory', {}).then(res => {
      if (res.success) {
        this.warehouseData = res.result
      }
    })
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    changeItemCategory(data) {
      return new Dictionary(data)
    },
    changeItem(data) {
      return new Item(data)
    },
    getData(classification, args) {
      this.classification = new Dictionary(classification)
      if (this.classification.isNew()) {
        return this.$message.warning('请先选择客户分类')
      }
      this.loading = true
      let query = { 'classification.id': this.classification.id }
      if (args) {
        Object.assign(query, args)
      }
      findAll('validityConfigFactory', query, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new ValidityConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      if (this.classification.isNew()) {
        return this.$message.warning('请先选择客户分类')
      }
      const record = new ValidityConfig()
      record.classification = this.classification
      this.data.push(record)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('validityConfigPersister', saveData).then(res => {
          if (res.success) {
            this.getData()
            this.$message.success('保存成功')
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    search(classification, args) {
      this.page = 1
      this.getData(classification, args)
    },
    openModal(modal, args, e) {
      this.$refs[modal].open(args, e)
    }
  }
}
</script>